import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { categories, stats } from '@/mocks/categories';

const platformStats = [
  { label: '累计爆料', value: '12,580', icon: 'ri-file-text-line' },
  { label: '活跃用户', value: '3,200万', icon: 'ri-user-heart-line' },
  { label: '覆盖平台', value: '36', icon: 'ri-apps-line' },
  { label: '合作媒体', value: '200+', icon: 'ri-shake-hands-line' },
];

const contactInfo = [
  { label: '商务合作邮箱', value: 'business@91onlinechigua.com', icon: 'ri-mail-line' },
  { label: '爆料投稿邮箱', value: 'tips@91onlinechigua.com', icon: 'ri-send-plane-line' },
  { label: '工作时间', value: '周一至周日 9:00 - 21:00', icon: 'ri-time-line' },
];

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '91在线吃瓜',
      url: 'https://91onlinechigua.com',
      description: '91在线吃瓜网是一个汇集网红爆料、明星黑料、热门追踪等最新吃瓜资讯的娱乐平台。每日更新，吃瓜群众首选入口。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'business@91onlinechigua.com',
        contactType: 'business cooperation',
      },
    },
    {
      '@type': 'WebPage',
      name: '关于我们 - 91在线吃瓜',
      url: 'https://91onlinechigua.com/about',
      description: '了解91在线吃瓜的品牌故事、平台数据与合作联系方式。',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://91onlinechigua.com' },
        { '@type': 'ListItem', position: 2, name: '关于我们' },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '91在线吃瓜网是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '91在线吃瓜网是一个汇集网红爆料、明星黑料、热门追踪等最新吃瓜资讯的娱乐平台。我们每日更新50条以上最新内容，覆盖抖音、快手、B站、小红书、视频号等36个主流平台。',
          },
        },
        {
          '@type': 'Question',
          name: '如何向91在线吃瓜投稿爆料？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以将爆料内容发送至我们的爆料投稿邮箱 tips@91onlinechigua.com，编辑团队将在24小时内审核并回复。请确保投稿内容真实可信，并附上相关证据材料。',
          },
        },
        {
          '@type': 'Question',
          name: '91在线吃瓜网的内容来源是否可靠？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的内容来源于各大社交平台、官方公告、媒体报道以及前线吃瓜群众的一手投稿。编辑团队会对每一条信息进行多方核实后再行发布，确保内容质量。',
          },
        },
        {
          '@type': 'Question',
          name: '如何与91在线吃瓜进行商务合作？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '商务合作请发送邮件至 business@91onlinechigua.com，我们的商务团队将在48小时内与您取得联系，洽谈具体合作事宜。',
          },
        },
      ],
    },
  ],
};

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="关于我们 - 91在线吃瓜 | 品牌介绍与合作联系"
        description="了解91在线吃瓜的品牌故事与发展历程。汇集每日网红黑料、明星八卦与热门追踪，吃瓜群众首选入口。提供商务合作与爆料投稿联系方式。"
        keywords="91在线吃瓜,关于我们,品牌介绍,商务合作,爆料投稿,吃瓜平台"
        canonicalUrl="https://91onlinechigua.com/about"
        ogType="website"
        jsonLd={aboutJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="pt-24 pb-16 md:pt-32 md:pb-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto text-center">
                <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-3">
                  关于我们
                </p>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
                  做全网最懂你的
                  <br />
                  <span className="text-primary-600">吃瓜</span>平台
                </h1>
                <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                  91在线吃瓜创立于2024年，致力于为吃瓜群众提供最新、最全、最真实的网红爆料、明星黑料与热门追踪资讯。
                  我们深耕娱乐资讯领域，覆盖抖音、快手、B站、小红书、视频号等36个主流平台，日均更新50条以上独家爆料内容。
                  从网红人设崩塌到明星恋情曝光，从直播带货翻车到MCN行业内幕，这里有你想要的一切瓜 🍉
                </p>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
                  平台数据
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
                  {platformStats.map((stat) => (
                    <div key={stat.label} className="text-center p-6 rounded-2xl bg-background-100">
                      <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100">
                        <i className={`${stat.icon} text-xl text-primary-600`}></i>
                      </div>
                      <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                        {stat.value}
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-4xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
                  覆盖分类
                </h2>
                <p className="text-sm text-foreground-600 text-center mb-10 max-w-xl mx-auto">
                  六大内容分类，全方位覆盖吃瓜资讯的每一个角落
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {categories.map((cat) => (
                    <div key={cat.slug} className="flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70">
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                        <i className={`${cat.icon} text-lg text-primary-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900">{cat.name}</h3>
                        <p className="text-xs text-foreground-500 mt-1">{cat.description}</p>
                        <p className="text-[10px] text-primary-600 font-medium mt-2">{cat.count.toLocaleString()} 条爆料</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section id="contact" className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
                  商务合作与联系
                </h2>
                <p className="text-sm text-foreground-600 text-center mb-10">
                  欢迎品牌合作、内容授权与爆料投稿
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
                  {contactInfo.map((item) => (
                    <div key={item.label} className="p-5 rounded-2xl bg-background-100 text-center">
                      <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100">
                        <i className={`${item.icon} text-lg text-accent-600`}></i>
                      </div>
                      <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
                      <p className="text-sm font-medium text-foreground-900 break-all">{item.value}</p>
                    </div>
                  ))}
                </div>

                <div className="p-6 rounded-2xl bg-background-100">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-3">合作声明</h3>
                  <ul className="space-y-2 text-xs text-foreground-600 leading-relaxed">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                      本站所有内容均来源于公开渠道与用户投稿，编辑团队会对信息进行核实后发布。
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                      如涉及侵权或不实信息，请发送邮件至 business@91onlinechigua.com，我们将在24小时内处理。
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                      商业合作请邮件联系，我们提供品牌推广、内容定制、联合活动等多种合作形式。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section id="faq" className="py-14 md:py-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
                  常见问题
                </h2>
                <div className="space-y-4">
                  <div className="p-5 rounded-2xl bg-background-50 border border-background-200/70">
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                      91在线吃瓜网是什么？
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      91在线吃瓜网是一个汇集网红爆料、明星黑料、热门追踪等最新吃瓜资讯的娱乐平台。我们每日更新50条以上最新内容，覆盖抖音、快手、B站、小红书、视频号等36个主流平台，是吃瓜群众获取第一手娱乐资讯的首选入口。
                    </p>
                  </div>
                  <div className="p-5 rounded-2xl bg-background-50 border border-background-200/70">
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                      如何向91在线吃瓜投稿爆料？
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      您可以将爆料内容发送至我们的爆料投稿邮箱 tips@91onlinechigua.com，编辑团队将在24小时内审核并回复。请确保投稿内容真实可信，并附上相关证据材料。我们会对投稿人信息严格保密。
                    </p>
                  </div>
                  <div className="p-5 rounded-2xl bg-background-50 border border-background-200/70">
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                      91在线吃瓜网的内容来源是否可靠？
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      我们的内容来源于各大社交平台、官方公告、媒体报道以及前线吃瓜群众的一手投稿。编辑团队会对每一条信息进行多方核实后再行发布，确保为读者提供高质量、可信赖的娱乐资讯内容。
                    </p>
                  </div>
                  <div className="p-5 rounded-2xl bg-background-50 border border-background-200/70">
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                      如何与91在线吃瓜进行商务合作？
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">
                      商务合作请发送邮件至 business@91onlinechigua.com，我们的商务团队将在48小时内与您取得联系，洽谈具体合作事宜。我们支持品牌推广、内容定制、联合活动等多种合作形式。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="disclaimer" className="py-14 md:py-16 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-4 text-center">
                  免责声明
                </h2>
                <div className="text-xs text-foreground-600 leading-relaxed space-y-2 p-5 rounded-2xl bg-background-100">
                  <p>1. 本站内容来源于网络公开信息、用户投稿及合作媒体，仅供娱乐参考之用，不构成任何投资、消费或法律建议。</p>
                  <p>2. 本站力求所发布信息的真实性与准确性，但不对其完整性、时效性作任何保证。如发现不实信息，请及时联系我们进行更正。</p>
                  <p>3. 如本站内容涉及您的合法权益（包括但不限于名誉权、隐私权、著作权等），请发送相关证明材料至 business@91onlinechigua.com，我们将在核实后24小时内处理。</p>
                  <p>4. 未经本站书面授权，禁止任何形式的转载、镜像或商业使用。如需内容合作，请通过商务邮箱联系我们。</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}